import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { motion } from 'framer-motion';
import { FaShieldAlt, FaCheckCircle, FaUsers } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const AcademicQualityCommission = () => {
  const { t } = useTranslation();

  const committeeMembers = [
    { name: 'Hatice Mergen', title: 'Prof. Dr.', role: t('academic_quality_commission.president'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5582' },
    { name: 'Canan Köroğlu', title: 'Prof. Dr.', role: t('academic_quality_commission.vice_president'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/6842' },
    { name: 'Uğur Karabey', title: 'Doç. Dr.', role: t('academic_quality_commission.member'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5811' },
    { name: 'Barış Temelli', title: 'Prof. Dr.', role: t('academic_quality_commission.member'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5902' },
    { name: 'Serpil Aktaş Altunay', title: 'Prof. Dr.', role: t('academic_quality_commission.member'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/5439' },
    { name: 'İsmet Yurduşen', title: 'Prof. Dr.', role: t('academic_quality_commission.member'), imageUrl: 'https://avesis.hacettepe.edu.tr/user/image/7241' },
    { name: 'Gülnihal Doğruyol Aslan', title: t('faculty_secretary.title'), role: t('academic_quality_commission.rapporteur'), imageUrl: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/gulnihaldogruyolaslan.jpg' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  const MemberCard = ({ member }) => (
    <motion.div
      variants={itemVariants}
      whileHover={{ scale: 1.05, y: -5, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' }}
      className="bg-white rounded-xl shadow-lg text-center p-6 transition-all duration-300 ease-in-out border-t-4 border-red-600"
    >
      <div className="mb-4">
        <img
          src={member.imageUrl}
          alt={member.name}
          className="w-32 h-32 rounded-full mx-auto object-cover border-4 border-gray-100 shadow-md"
          onError={(e) => {
            e.target.src = `https://ui-avatars.com/api/?name=${member.name.replace(' ', '+')}&background=DC2626&color=fff&size=128&bold=true&rounded=true`;
          }}
        />
      </div>
      <h3 className="text-xl font-bold text-gray-800">{member.name}</h3>
      <p className="text-md text-gray-500 mb-3">{member.title}</p>
      <div className="flex items-center justify-center text-gray-700 bg-gray-50 px-4 py-2 rounded-lg">
        <FaShieldAlt className="mr-2 text-red-600" />
        <span className="font-medium text-sm">{member.role}</span>
      </div>
    </motion.div>
  );

  return (
    <PageTemplate
      title={t('academic_quality_commission.title')}
      subtitle={t('academic_quality_commission.subtitle')}
    >
      <div className="container mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center bg-white p-8 rounded-2xl shadow-xl mb-16 border-b-4 border-red-600"
        >
          <h2 className="text-3xl font-extrabold text-gray-800 mb-4 flex items-center justify-center">
            <FaCheckCircle className="mr-3 text-red-600" /> {t('academic_quality_commission.mission_title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {t('academic_quality_commission.mission_description')}
          </p>
        </motion.div>

        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-10 flex items-center justify-center">
            <FaUsers className="mr-3 text-red-800" /> {t('academic_quality_commission.committee_members')}
          </h2>
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10"
          >
            {committeeMembers.map((member, index) => (
              <MemberCard key={index} member={member} />
            ))}
          </motion.div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default AcademicQualityCommission;